import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import {
  doGet,
  useDelete,
  useGet,
  usePost,
  usePut,
} from "../common/fetchServices";
import { API_BASE_URL, PROCESSING_BASE_URL } from "../props";
import { isBlank } from "../util/ext";
import { or } from "ramda";

const getContentProvidersUrl = () =>
  `${PROCESSING_BASE_URL}/workflow-manager/api/content-provider`;
const getContentProviderUrl = ({ contentProviderId }) =>
  `${PROCESSING_BASE_URL}/workflow-manager/api/content-provider/${contentProviderId}`;

const getContentProviderEndpointsUrl = ({ contentProviderId }) =>
  `${PROCESSING_BASE_URL}/workflow-manager/api/content-provider/${contentProviderId}/endpoints`;
const getContentProviderEndpointUrl = ({
  contentProviderId,
  contentProviderEndpointId,
}) =>
  `${PROCESSING_BASE_URL}/workflow-manager/api/content-provider/${contentProviderId}/endpoints/${contentProviderEndpointId}`;

export const useContentProviders = () => {
  const baseUrl = getContentProvidersUrl();
  const url = `${baseUrl}?size=999`;
  return useGet(["content-providers"], url);
};

export const useContentProviderEndpoints = contentProviderId => {
  const url = `${PROCESSING_BASE_URL}/workflow-manager/api/content-provider/${contentProviderId}/endpoints`;
  return useGet(["content-provider-endpoints", contentProviderId], url);
};

export const useContentProviderCreate = () => {
  return usePost(getContentProvidersUrl, {
    queriesToInvalidate: ["content-providers"],
  });
};

export const useContentProviderDelete = () => {
  return useDelete(getContentProviderUrl, {
    queriesToInvalidate: ["content-providers"],
  });
};

export const useContentProviderUpdate = () => {
  return usePut(getContentProviderUrl, {
    queriesToInvalidate: [
      ["content-provider"],
      ["content-provider", ["contentProviderId"]],
    ],
  });
};

export const useContentProviderEndpointCreate = () => {
  return usePost(getContentProviderEndpointsUrl, {
    queriesToInvalidate: ["content-provider-endpoints"],
  });
};

export const useContentProviderEndpoint = (
  contentProviderId,
  contentProviderEndpointId,
) => {
  const auth = useSelector(state => state.auth);
  const url = `${PROCESSING_BASE_URL}/workflow-manager/api/content-provider/${contentProviderId}/endpoints/${contentProviderEndpointId}`;

  return useQuery(
    [
      "content-provider-endpoint",
      {
        contentProviderId,
        contentProviderEndpointId,
      },
    ],
    () => {
      //-- If either id is blnak just return a resolved Promise of null
      if (or(isBlank(contentProviderId), isBlank(contentProviderEndpointId))) {
        return Promise.resolve(null);
      }

      return doGet(auth)(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    },
  );
};

export const useContentProviderEndpointUpdate = () => {
  return usePut(getContentProviderEndpointUrl, {
    queriesToInvalidate: [
      ["content-provider-endpoints"],
      [
        "content-provider-endpoint",
        ["contentProviderId", "contentProviderEndpointId"],
      ],
    ],
  });
};

export const useContentProviderEndpointDelete = () => {
  return useDelete(getContentProviderEndpointUrl, {
    queriesToInvalidate: ["content-provider-endpoints"],
  });
};

export const useAllModules = () => {
  const url = `${API_BASE_URL}/admin/modules?limit=all`;
  return useGet(["modules-all"], url);
};
